import React from 'react';
import { connect } from 'react-redux';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  Spinner,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faPlus } from '@fortawesome/pro-light-svg-icons';
import { saveUpdatedTranslations } from '../../../actions/translations';

class AddModal extends React.PureComponent {
  handleChange = (event) => {
    const { dispatch } = this.props;
    dispatch({ type: 'UPDATE_ADDED_LANGUAGE_NAME', payload: event.target.value });
  };

  handleAdd = (addedLanguageName, translations, site) => {
    if (addedLanguageName === '') {
      // TODO: Please use a proper UI library for alerts like this.
      // alert('Please enter a language name.');
    } else {
      const newLanguage = { [addedLanguageName]: translations[Object.keys(translations)[0]] };
      const newTranslationObject = Object.assign(translations, newLanguage);
      saveUpdatedTranslations(newTranslationObject, site, false, true).then(() => this.close());
    }
  };

  close = () => {
    const { dispatch } = this.props;
    dispatch({ type: 'SET_ADD_TRANSLATION_MODAL', payload: false });
    dispatch({ type: 'UPDATE_ADDED_LANGUAGE_NAME', payload: '' });
  };

  render() {
    const {
      isOpen,
      translations,
      site,
      adding,
      addedLanguageName,
    } = this.props;
    return (
      <Modal isOpen={isOpen} toggle={this.close} zIndex="100000">
        <ModalHeader toggle={this.close}>Add Language Name</ModalHeader>
        <ModalBody>
          <div className="mb-2">
            The new language will be modeled after the&nbsp;
            {Object.keys(translations)[0]}
            &nbsp;template.
          </div>
          <Input
            type="text"
            onChange={(event) => this.handleChange(event)}
          />
        </ModalBody>
        <ModalFooter>
          <Button
            color="success"
            onClick={() => this.handleAdd(addedLanguageName, translations, site)}
            disabled={adding}
          >
            <FontAwesomeIcon icon={faPlus} size="lg" className="me-2" />
            Add
            {adding && <Spinner size="sm" className="ms-2" />}
          </Button>
          <Button color="danger" onClick={this.close}>
            <FontAwesomeIcon icon={faTimes} size="lg" className="me-2" />
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

const mapStateToProps = (store) => ({
  isOpen: store.modals.addTranslationOpen,
  translations: store.translations.sets,
  addedLanguageName: store.translations.addedLanguageName,
  adding: store.translations.adding,
});

export default connect(mapStateToProps)(AddModal);
